import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

const PADDING_TOP = theme.spacing(4);

export const containerStyle = css`
  margin-top: auto;
  padding-top: ${PADDING_TOP};
  max-height: calc(30% - ${PADDING_TOP});
  display: flex;
  flex-direction: column;

  @container submission-details-side-panel (max-height: 800px) {
    max-height: calc(40% - ${PADDING_TOP});
  }
`;
